import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

VIV.behaviours.mobileDrawer = (function () {

    const baseClass = 'mobileDrawer';

    const attach = function (context) {
        const drawer = context.querySelector(`.${baseClass}`);
        const toggleButtons = context.querySelectorAll(`.behaviourToggleMobileDrawer`);

        // No menu found, so exit
        if (!drawer) {
            return false;
        }

        // Behaviour already attached, so exit
        if (drawer.classList.contains(`${baseClass}--behaviourAttached`)) {
            return false;
        }

        drawer.classList.add(`${baseClass}--behaviourAttached`);

        toggleButtons.forEach((button) => {
            init(drawer, button);
        });
    };

    const init = function (drawer, toggleButton) {
        toggleButton.addEventListener('click', function () {
            const open = drawer.classList.toggle(`${baseClass}--open`);
            drawer.classList.toggle(`${baseClass}--closed`, !open);
            if (open) {
                disableBodyScroll(drawer);
                if (typeof VIV.behaviours.mobileMenu != 'undefined') {
                    VIV.behaviours.mobileMenu.reset();
                }
            } else {
                enableBodyScroll(drawer);
            }
        });
    };

    return {
        attach: attach
    }
})();
